import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

interface ArchiveProjectModalProps {
  onConfirm: (archiveExclusiveRelated: boolean) => void;
  onHide: () => void;
  show: boolean;
}

const ArchiveProjectForm = ({
  onConfirm,
  onHide,
}: Omit<ArchiveProjectModalProps, 'show'>) => {
  const { t } = useTranslation();
  const [archiveExclusiveRelated, setArchiveExclusiveRelated] = useState(false);

  return (
    <>
      <Modal.Body>
        <div className="form-check">
          <input
            checked={archiveExclusiveRelated}
            className="form-check-input"
            id="archive-exclusive-related"
            onChange={event => setArchiveExclusiveRelated(event.target.checked)}
            type="checkbox"
          />
          <label
            className="form-check-label"
            htmlFor="archive-exclusive-related"
          >
            {t('archiveExclusiveRelated')}
          </label>
        </div>
        <p className="text-muted mt-2 mb-0">
          {t('archiveExclusiveRelatedHelp')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={onHide}
          variant="outline-secondary"
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={() => onConfirm(archiveExclusiveRelated)}
          variant="primary"
        >
          {t('archiveProject')}
        </Button>
      </Modal.Footer>
    </>
  );
};

const ArchiveProjectModal = ({
  onConfirm,
  onHide,
  show,
}: ArchiveProjectModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      onHide={onHide}
      show={show}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('archiveProjectTitle')}</Modal.Title>
      </Modal.Header>
      {show && (
        <ArchiveProjectForm
          onConfirm={onConfirm}
          onHide={onHide}
        />
      )}
    </Modal>
  );
};

export default ArchiveProjectModal;
